module.exports = __webpack_public_path__ + "img/news_expo2.9fee5991.jpg";